import type { AiService } from '@/context/services/ai_service_setting/type';
import { useTranslation } from '@/i18n';
import {
  ButtonV2,
  Caption,
  Heading,
} from '@moneyforward/ap-frontend-components';
import { Divider } from 'antd';
import classnames from 'classnames/bind';
import { FC, useCallback, useState } from 'react';
import { ModelTrainingSetting } from '../ModelTrainingSetting/ModelTrainingSetting';
import { AiAgreementLink } from '../aiAgreementLink';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);
type InitialSettingProps = {
  isAgreementPending: boolean;
  initialIsModelTrainingAllowed: boolean;
  onAgreement: (isModelTrainingAllowed: boolean) => void;
  services: AiService[];
};

export const InitialSetting: FC<InitialSettingProps> = ({
  isAgreementPending,
  initialIsModelTrainingAllowed,
  onAgreement,
  services,
}) => {
  const { t } = useTranslation();
  const [isModelTrainingAllowed, setIsModelTrainingAllowed] = useState(
    initialIsModelTrainingAllowed
  );
  const handleAgreement = useCallback(() => {
    onAgreement(isModelTrainingAllowed);
  }, [onAgreement, isModelTrainingAllowed]);

  return (
    <div className={cx('container')} data-testid='initial-setting'>
      <Heading as='h2' weight='normal'>
        {t('ai_service_setting.initial_heading')}
      </Heading>
      <section className={cx('providedServices')}>
        <p>{t('ai_service_setting.provided_services_heading')}</p>
        <ul className={cx('providedServicesList')}>
          {services.map(({ description, name, service_type }) => (
            <li key={service_type}>
              <p>{name}</p>
              <Caption icon={false} type='helper'>
                {description}
              </Caption>
            </li>
          ))}
        </ul>
      </section>
      <Divider style={{ margin: 0 }} />
      <div className={cx('agreementDescription')}>
        <p>{t('ai_service_setting.agreement_required')}</p>
        <AiAgreementLink />
      </div>
      <ModelTrainingSetting
        isAllowed={isModelTrainingAllowed}
        isInitial
        onChange={setIsModelTrainingAllowed}
      />
      <Caption icon={false} type='helper'>
        {t('ai_service_setting.operation_notice')}
      </Caption>
      <ButtonV2
        color='primary'
        isDisabled={isAgreementPending}
        onClick={handleAgreement}
        size='sm'
        type='button'
      >
        {t('ai_service_setting.agree_and_start_button')}
      </ButtonV2>
    </div>
  );
};
